import strings from 'owa-strings/owa-options-strings';
export default function getClauseSectionProperties(sectionType) {
    switch (sectionType) {
        case 'conditional':
            return {
                addClauseText: strings.options_inboxRules_addCondition,
                headerText: strings.options_inboxRules_conditionsHeader,
                calloutText: strings.options_inboxRules_conditionsInfo,
                isOptional: false,
            };
        case 'action':
            return {
                addClauseText: strings.options_inboxRules_addAction,
                headerText: strings.options_inboxRules_actionsHeader,
                calloutText: strings.options_inboxRules_actionsInfo,
                isOptional: false,
            };
        case 'exception':
            return {
                addClauseText: strings.options_inboxRules_addException,
                headerText: strings.options_inboxRules_exceptionsHeader,
                calloutText: strings.options_inboxRules_exceptionsInfo,
                isOptional: true,
            };
        case 'name':
            return null;
        default:
            throw new Error('Cannot get section properties for section that does not exist');
    }
}
//# sourceMappingURL=getClauseSectionProperties.js.map